document.addEventListener('DOMContentLoaded', async () => {
  // Define UI elements and values.
  let _config = {
    // Values
    text_reset_timer:          1000,
    shipping_price:            2900,
    shipping_threshold:        40000,
    
    // Button text
    text_add:                  'Køb',
    text_adding:               'Tilføjer...',
    text_added:                'Tilføjet!',
    text_remove:               'Fjern',
    text_removing:             'Fjerner...',
    text_removed:              'Fjernet!',
    text_sold_out:             'Udsolgt',
    
    // Messages
    confirm_item_removal:      'Er du sikker på, at du vil slette dette element fra din kurv?',
    alert_not_enough_in_stock: 'Vi har i øjeblikket ikke flere af denne vare på lager. Kontakt os endelig for forespørgsler om større antal.',
    
    // Header elements
    header_cta_shipping:       '.main-menu__cart-wrapper .cart-wrapper__shipping .cart-wrapper__text',
    header_items_count:        '.cart-wrapper__cart-overview .notification__counter',
    header_items_total_price:  '.main-header__row .listed-prices__items-total-price',
    header_shipping_price:     '.main-header__row .listed-prices__shipping-price',
    header_cart_total_price:   '.cart-wrapper__cart-overview .cart-overview',
    
    // Cart drawer elements
    drawer_items_count:        '#header .cart-items-count',
    drawer_item_list:          '#cart ul.mm-list',
    drawer_items:              '#cart .cart-items-list-mobile a',
    drawer_cta_shipping:       '#cart .shipping-message-mobile',
    drawer_label:              '#cart .mm-label',
    drawer_shipping_price:     '#cart .cart-shipping-delivery',
    drawer_final_price:        '#cart .cart-final-price',
    drawer_continue_button:    '#cart .go-to-cart-button',
    drawer_progress_container: '#cart .cart-progress-container',
    drawer_timer:              '#cart .cart-timer',
    drawer_form:               '#cart .cart-form',
    
    // Progress bar
    progress_bars:             '.cart_progress_bar',
    progress_steps:            '.cart-progress-container ul li',
    
    // Product page elements
    clerk_bundles_heading:     '.clerk-bundles-heading',
    product_cta_shipping:      '.product-info__block .addon-heading',
    
    // Cart page elements
    cta_shipping:              '#cart_form .cart_progress_title',
    cart_items_list:           '#cart_form .cart-items-list-mobile',
    cart_shipping_price3:      '#cart_form .shipping-price',
    cart_final_price:          '#cart_form .cart-final-price span',
  };
  
  const $ = document.querySelector.bind(document);
  const $$ = document.querySelectorAll.bind(document);
  const product_list = $('body.cart') ? '.cart_product' : _config.drawer_items;
  
  // Convert number to store's currency.
  let formatCurrency = (int) => {
    return new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' }).format(int / 100);
  };
  
  // Fetch cart.js async and display cart drawer.
  const renderCartDrawer = async (open_cart = true) => {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      if (!response.ok) {
        throw new Error('Network response was not OK');
      }
      let cart = await response.json();
      
      let cart_items = '';
      
      // Replace forEach with for...of loop to handle async operations correctly
      for (const item of cart.items) {
        let item_image = item.image.concat('&', 'width=80');
        let item_path = item.url.split('?')[0].concat('.', 'js');

        try {
          const productResponse = await fetch(item_path);
          if (!productResponse.ok) {
            throw new Error(`Could not fetch product: ${item.id}`);
          }
          const product = await productResponse.json();
          
          // Only create cart item for the variant that is actually in the cart
          const cartVariant = product.variants.find(variant => variant.id === item.variant_id);
          if (cartVariant) {
            // Create new product DOM element.
            let on_sale = cartVariant.compare_at_price > 0 ? true : false;
            let sale_banner = '';
            let sale_class = '';
            let compare_at_price = '';

            if (on_sale) {
              sale_banner = `
                <div class="product-label-container top-0">
                  <div class="product-label product-label--sale"><p>Spar</p><p>${Math.round(((cartVariant.compare_at_price - item.price) * 100) / cartVariant.compare_at_price)}%</p></div>
                </div>`;

              sale_class = 'sale'

              compare_at_price = `<span class="cart_before_price">${formatCurrency(cartVariant.compare_at_price * item.quantity)}</span>`;
            }

            let newCartItem = document.createElement('a');
            newCartItem.setAttribute('onclick', 'return false;');
            newCartItem.dataset.variant = item.variant_id;
            newCartItem.dataset.key = item.key;
            newCartItem.innerHTML = `
              <div class="cart_product flex">
                <div class="cart_image">
                  <img src="${item_image}" alt="${item.title}" loading="lazy" width="80" height="80" onclick="redirectToPath('${item.url}')" />
                  ${sale_banner}
                </div>
                <div class="cart_product_info">
                  <div class="cart_title" onclick="redirectToPath('${item.url}')" style="text-overflow: ellipsis;">${item.title}</div>
                  <div class="cart_prices flex">
                    <div class="cart_price_per_item" data-price="${item.discounted_price}">${formatCurrency(item.discounted_price)} pr. stk.</div>
                    <div class="cart_price ${sale_class}">
                      <span class="current_price">${formatCurrency(item.final_line_price)}</span>
                      ${compare_at_price}
                    </div>
                  </div>

                  <div class="cart_handler flex">
                    <div class="cart_qty_controller flex">
                      <button class="cart_button remove flex" data-action="decrease">-</button>
                      <input type="number" class="cart_item_qty" value="${item.quantity}" min="1" min="1" max="${cartVariant.inventory_quantity}">
                      <button class="cart_button add flex" data-action="increase">+</button>
                    </div>
                    <span class="cart_remove_item">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="#9f9f9f" viewBox="0 0 448 512"><path d="M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z"/></svg>
                    </span>
                  </div>
                </div>
              </div>
              <span class="loader-wrapper" style="display:none;"><div class="loader"></div></span>
            `;

            cart_items += newCartItem.outerHTML;
          }
        } catch (err) {
          console.error('Error:', err);
        } finally {
          // Update cart drawer items.
          $('.cart-items-list-mobile').innerHTML = cart_items;
          
          // Update cart drawer button listeners.
          cartDrawerBtnListeners();
          
          // Open cart drawer
          if(open_cart && $('#header [href="#cart"]')) $('#header [href="#cart"]').click();
        }
      }
      
    } catch (err) {
      console.error('Error:', err);
    }
  };

  // Updates all UI elements.
  let cartUpdater = (open_cart = true) => {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => {
        if (!response.ok) { throw new Error('Network response was not OK') };
        return response.json();
      })
      .then((cart) => {
        let cart_final_price = cart.total_price + _config.shipping_price;
        let amount_needed_for_free_shipping = _config.shipping_threshold - cart.total_price;
        let remaining_free_shipping_price = formatCurrency(amount_needed_for_free_shipping);
        let adjusted_cart_total_price = cart.total_price > (_config.shipping_threshold - 5500) && cart.total_price < _config.shipping_threshold ? cart.total_price - 5500 : cart.total_price;
        
        // Scroll to top of cart drawer
        $(_config.drawer_item_list).scroll({ top: 0, behavior: 'smooth' });
        
        // Desktop header
        $(_config.header_cta_shipping).innerHTML = cart.total_price < _config.shipping_threshold ? `Fri fragt !<br />Køb for ${formatCurrency(amount_needed_for_free_shipping)}` : 'Fri fragt !';
        $(_config.header_items_count).innerHTML = $(_config.header_items_count).dataset.max && cart.item_count > parseInt($(_config.header_items_count).dataset.max, 10) ? $(_config.header_items_count).dataset.max + '+' : (cart.item_count > 0 ? cart.item_count : '');
        //$(_config.header_items_total_price).innerHTML = cart.item_count > 0 ? formatCurrency(cart.total_price) : '0 kr.';
        //$(_config.header_shipping_price).innerHTML = cart.total_price < _config.shipping_threshold ? formatCurrency(_config.shipping_price) : '0 kr.';
        $(_config.header_cart_total_price).innerHTML = cart.item_count > 0 ? `${cart.item_count} ${cart.item_count === 1 ? 'vare' : 'varer'} til: ${cart.total_price < _config.shipping_threshold ? formatCurrency(cart_final_price) : formatCurrency(cart.total_price)}` : 'Ingen varer';
        
        // Cart drawer
        $(_config.drawer_items_count).innerHTML = cart.item_count;
        $(_config.drawer_items_count).style.display = cart.item_count > 0 ? 'inline': 'none';
        $(_config.drawer_label).innerHTML = cart.item_count > 0 ? '' : 'Din indkøbskurv er tom';
        $(_config.drawer_shipping_price).innerHTML = cart.item_count > 0 ? `<span><p>Fragt og leveringsomk.</p><p><strong>${cart.total_price < _config.shipping_threshold ? formatCurrency(_config.shipping_price) : '0 kr.'}</strong></p></span>` : '';
        $(_config.drawer_progress_container).innerHTML = cart.item_count > 0 ? `
          <a href="/cart">
            <progress class="cart_progress_bar" value="${adjusted_cart_total_price}" max="${_config.shipping_threshold}">${adjusted_cart_total_price}</progress>
            <ul class="cart_progress_steps mm-list">
              <li ${cart.total_price < _config.shipping_threshold ? '' : 'class="achieved" '}data-step-value="${_config.shipping_threshold}" style="left: calc((${_config.shipping_threshold} / ${_config.shipping_threshold} * 100%) - 15px);"></li>
            </ul>
          </a>` : '';
        $(_config.drawer_cta_shipping).innerHTML = cart.item_count > 0 ? cart.total_price < _config.shipping_threshold ? `<a href="/cart" style="color: #000;"><strong>KØB FOR ${remaining_free_shipping_price} MERE <br> OG FÅ FRI FRAGT !</strong></a>` : '<a href="/cart" style="color: #008000;"><strong>FRI FRAGT !<br><br></strong></a>' : '';
        if($(_config.drawer_timer)) $(_config.drawer_timer).style.display = cart.item_count > 0 ? 'block' : 'none';
        if($(_config.drawer_final_price)) $(_config.drawer_final_price).innerHTML = cart.item_count > 0 ? `<p><strong>Samlet pris</strong></p><p><strong>${cart.total_price < _config.shipping_threshold ? formatCurrency(cart_final_price) : formatCurrency(cart.total_price)}</strong></p>` : '';
        if($(_config.drawer_form)) $(_config.drawer_form).style.display = cart.item_count > 0 ? 'block' : 'none';
        
        // Progress bar
        $$(_config.progress_bars).forEach((progress_bar) => {
          progress_bar.innerHTML = adjusted_cart_total_price;
          progress_bar.setAttribute("value", adjusted_cart_total_price);
        });
        $$(_config.progress_steps).forEach((step) => {
          cart.total_price >= step.dataset.stepValue ? step.classList.add("achieved") : step.classList.remove("achieved");
        });
        
        // Product page
        if($(_config.clerk_bundles_heading)) $(_config.clerk_bundles_heading).innerHTML = cart.total_price < _config.shipping_threshold ? `Køb for ${formatCurrency(amount_needed_for_free_shipping)} ${cart.item_count > 0 ? 'mere ' : ''}og få <span style="color:#0da00d;">fri fragt</span> !` : '<span style="color:#0da00d;">Fri fragt !</span>';
        if($(_config.product_cta_shipping)) $(_config.product_cta_shipping).innerHTML = cart.total_price < _config.shipping_threshold ? `Køb for ${formatCurrency(amount_needed_for_free_shipping)} ${cart.item_count > 0 ? 'mere ' : ''}og få <span style="color:#0da00d;">fri fragt</span> !` : '<span style="color:#0da00d;">Fri fragt !</span>';

        if(cart.total_discount > 0 || cart.items.length !== $$(product_list).length) {
          renderCartDrawer(open_cart);

        } else {
          cart.items.forEach((item) => {
            let item_path = item.url.split('?')[0].concat('.', 'js');
            
            // Fetch product from path
            fetch(item_path)
              .then(response => {
                if (!response.ok) { throw new Error(`Could not fetch product: ${item.id}`) };
                return response.json();
              })
              .then((product) => {
                product.variants.forEach(variant => {
                  let compare_at_price = variant.compare_at_price > 0 ? formatCurrency(variant.compare_at_price * item.quantity) : '';
                  $$(product_list).forEach((element) => {
                    if(item.key === element.dataset.key) {
                      element.querySelector('.cart_price_per_item').innerHTML = `${formatCurrency(item.discounted_price)} pr. stk.`;
                      element.querySelector('.current_price').innerHTML = formatCurrency(item.final_line_price);
                      if(element.querySelector('.cart_before_price')) element.querySelector('.cart_before_price').innerHTML = compare_at_price;
                      element.querySelector('.cart_item_qty').value = item.quantity;
                    }
                  });
                });
              })
              .catch((err) => {
                console.error('Error:', err);
              });
          });
        }
      })
      .catch((err) => {
        console.error('Error:', err);
      });
  }

  // Add item to cart.
  let cartAddItem = (element) => {
    let item_id = element.querySelector('[name="id"]').value;
    
    // Set button text to "Adding to cart..." and disable button
    let submitBtn = element.querySelector('input[type="submit"');
    if(submitBtn) {
      submitBtn.value = _config.text_adding;
      submitBtn.setAttribute('disabled', true);
    }
    
    let items = [];
    // Check if element has multiple items and add them to the items array.
    if (element.querySelector('[name="items[]"]')) {
      element.querySelectorAll('[name="items[]"]').forEach((child_element) => {
        items.push(JSON.parse(child_element.value));
      });
    }
    items.push({
      'id': item_id,
      'quantity': 1
    });
    
    let formData = {
      'items': items
    };
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(response => {
        if (response.status === 422) {
          // Set button text to "Sold out" and alert user.
          if(submitBtn) submitBtn.value = _config.text_sold_out;
          
          // Alert for quantity.
          alert(_config.alert_not_enough_in_stock);
          
          throw new Error('Product is sold out');
        } else if (!response.ok) {
          throw new Error('Network response was not OK');
        }
        
        // Set button text to "Added to cart"
        if(submitBtn) submitBtn.value = _config.text_added;
        
        return response.json();
      })
      .catch((err) => {
        console.error('Error:', err);
      })
      .finally(async () => {
        if($('body.cart')) {
          location.reload();
  
        } else {
          cartUpdater();
          await renderCartDrawer();
          
          setTimeout(() => {
            // Reset button text to default
            if(submitBtn) {
              submitBtn.value = _config.text_add;
              submitBtn.removeAttribute('disabled');
            }
          }, 2500);
        }
      });
  }

  // Fetch "cart/change.js" and update item quantity.
  let cartChangeQty = async (element, quantity, cart = false) => {

    // If cart it false, fetch cart.js
    if(!cart) {
      // const response = await fetch(window.Shopify.routes.root + 'cart.js');
      // const cart = await response.json();
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not OK');
          }
          return response.json();
        })
        .then((cart) => {
          cartChangeQty(element, quantity, cart);
        })
        .catch((err) => {
          console.error('Error:', err);
        });
      return;
    }

    // Disable quantity controller input and button elements.
    let qty_controllers = element.querySelectorAll('.cart_qty_controller input, .cart_qty_controller button');
    if(qty_controllers) qty_controllers.forEach(controller => controller.setAttribute('disabled', true));
    if(element.querySelector('.loader-wrapper')) element.querySelector('.loader-wrapper').style.display = 'flex';
    
    // IMPORTANT: Use item.key! Otherwise items with discounts will be buggy!
    let formData = {
      'id': element.dataset.key,
      'quantity': quantity
    };
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData),
    })
    .then(response => {
      if (response.status === 422) {
        // Alert for quantity.
        let max_qty = element.querySelector('.cart_item_qty').max;
        alert(quantity > max_qty ? `Vi har i øjeblikket kun ${max_qty} stk. af denne vare på lager. Kontakt os endelig for forespørgsler om større antal.` : _config.alert_not_enough_in_stock);
        
        location.reload();
      } else if (!response.ok) {
        throw new Error('Product quantity could not be updated.');
      }
      return response.json();
    })
    .catch((err) => {
      console.error('Error:', err);
    })
    .finally(() => {
      if($('body.cart')) {
        location.reload();

      } else {
        if(cart.total_discount === 0 || cart.items.length !== $$(product_list).length) {
          // Update item's quantity controller and enable elements.
          element.querySelector('.cart_item_qty').value = quantity;
          if(qty_controllers) qty_controllers.forEach(controller => controller.removeAttribute('disabled'));
          if(element.querySelector('.loader-wrapper')) element.querySelector('.loader-wrapper').style.display = 'none';
        }
        
        cartUpdater();
      }
    });
  }

  // Function for updating line item quantity based on mode.
  let setItemQty = (element, mode) => {
    let current_qty = parseInt(element.querySelector('.cart_item_qty').value);
    if(!current_qty) return;

    let updated_qty = mode === 'add' ? current_qty + 1 : mode === 'subtract' ? current_qty - 1 : mode === 'remove' ? 0 : current_qty;
    
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not OK');
        }
        return response.json();
      })
      .then((cart) => {
        // Check if line item should be removed.
        if(updated_qty === 0) {
          let confirm_item_removal = confirm(_config.confirm_item_removal);
          if(confirm_item_removal === true) {
            cartChangeQty(element, updated_qty, cart);

            if(cart.total_discount === 0 || cart.items.length !== $$(product_list).length) {
              element.remove();
            }
          }
        } else {
          cartChangeQty(element, updated_qty, cart);
        }
      })
      .catch((err) => {
        console.error('Error:', err);
      })
  }

  // Cart form event listeners.
  const cartFormListener = (evt) => {
    evt.preventDefault();
    cartAddItem(evt.target);
  }
  
  // Init cart forms.
  const cartForms = () => {
    $$('form[action="/cart/add"]').forEach((form) => {
      if(!form.classList.contains('loaded')) {
        form.addEventListener('submit', cartFormListener);
        form.classList.add('loaded');
      }
    });
  }
  setInterval(() => {
    cartForms();
  }, 300);
  
  const cartDrawerBtnListeners = () => {
    $$(product_list).forEach((product) => {
      let add_button = product.querySelector('.cart_button.add');
      let subtract_button = product.querySelector('.cart_button.remove');
      let remove_button = product.querySelector('.cart_remove_item');
      let variant_qty = product.querySelector('.cart_item_qty');
      
      if(add_button) add_button.onclick = () => setItemQty(product, 'add');
      if(subtract_button) subtract_button.onclick = () => setItemQty(product, 'subtract');
      if(remove_button) remove_button.onclick = () => setItemQty(product, 'remove');
      if(variant_qty) variant_qty.onchange = () => cartChangeQty(product, variant_qty.value);
    });
  }
  cartDrawerBtnListeners();

  // Update cart when switching between tabs.
  document.addEventListener("visibilitychange", (evt) => {
    if (document.visibilityState == "visible") {
      const open_cart = false;
      cartUpdater(open_cart);
    }
  });
});